import { render } from "./LinkInvalido.vue?vue&type=template&id=48163e18"
import script from "./LinkInvalido.vue?vue&type=script&lang=js"
export * from "./LinkInvalido.vue?vue&type=script&lang=js"
script.render = render

export default script